import React from 'react'
import Cover from '../components/cover'
import ServicesCarousel from '../components/ServicesCarousel'
import AboutSection from '../components/AboutSection'
import BookingProcess from '../components/BookingProcess'
import PopularServices from '../components/PopularServices'
import Testimonials from '../components/Testimonials'
import CarpetPricing from '../components/CarpetPricing'

const Home = () => {
  return (
     <>
     <Cover/>
     <ServicesCarousel/>
    <AboutSection/> 
    <BookingProcess/>
     
     </>
    
  
  )
}

export default Home